import { render, staticRenderFns } from "./mo-account-panel.html?vue&type=template&id=4465f225&scoped=true&external"
import script from "./mo-account-panel.ts?vue&type=script&lang=ts&external"
export * from "./mo-account-panel.ts?vue&type=script&lang=ts&external"
import style0 from "./mo-account-panel.vue?vue&type=style&index=0&id=4465f225&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4465f225",
  null
  
)

export default component.exports